import { useState, useCallback } from 'react';
let toastId = 0;
export function useToast() {
    const [toasts, setToasts] = useState([]);
    const addToast = useCallback((type, message, duration) => {
        const id = `toast-${toastId++}`;
        const newToast = {
            id,
            type,
            message,
            duration,
            onClose: (id) => {
                setToasts((prev) => prev.filter((t) => t.id !== id));
            },
        };
        setToasts((prev) => [...prev, newToast]);
    }, []);
    const success = useCallback((message, duration) => {
        addToast('success', message, duration);
    }, [addToast]);
    const error = useCallback((message, duration) => {
        addToast('error', message, duration);
    }, [addToast]);
    const info = useCallback((message, duration) => {
        addToast('info', message, duration);
    }, [addToast]);
    const warning = useCallback((message, duration) => {
        addToast('warning', message, duration);
    }, [addToast]);
    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);
    return {
        toasts,
        success,
        error,
        info,
        warning,
        removeToast,
    };
}
